import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { NoItemsWrapper } from '../General/NoItemsWrapper';
import { ZemplinLoaderWrapper } from '../../..';
import { ArticleCard } from './ArticleCard';
import { SitemapLink } from './SitemapLink';

interface Props {
  sitemaps: Array<{ name: string; id: number | string }>;
  currentId: number | string;
  handleCategoryChange: (id) => void;
}

function SitemapList({ currentId, sitemaps, handleCategoryChange }: Props) {
  const articlesComponent =
    sitemaps &&
    sitemaps.map(s => {
      return (
        <SitemapLink
          handleCategoryChange={handleCategoryChange}
          key={s.id}
          title={s.name}
          id={s.id.toString()}
          active={currentId.toString() === s.id.toString()}
        />
      );
    });

  return (
    <Wrapper>
      <SitemapWrapper>{articlesComponent}</SitemapWrapper>
    </Wrapper>
  );
}

const SitemapWrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(324)};

  overflow-y: auto;

  @media only screen and (max-width: 1740px) {
    white-space: nowrap;
    flex-flow: row;
    margin: 0;
    padding: ${rem(24)} 0;
    max-width: initial;
    border-bottom: ${({ theme }) => theme.borders.primary};
    padding: ${rem(24)} ${rem(16)};
    margin: 0 auto;
    width: 100%;
  }
`;

const Wrapper = styled.div`
  margin-right: ${rem(36)};
  min-width: ${rem(136)};

  @media only screen and (max-width: 1740px) {
    margin-right: -${rem(16)};
    margin-left: -${rem(16)};
  }
`;

export { SitemapList };
